import { IResourceListProps } from "../../common/ra-types";
import { ListSearchFilter } from "../../common/list/ListSearchFilter";
import {
  useListContext,
  CreateButton,
  Datagrid,
  TextField,
  FunctionField,
  Record,
} from "react-admin";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import BeenHereOutlined from "@material-ui/icons/BeenhereOutlined";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { useSelector } from "react-redux";
import { AppState } from "../../../common/types";
import { Theme, useTheme } from "@material-ui/core";
import { RoleListDto } from "../../../common/data/service-proxies";
import { DeleteRecordMenuItem } from "../../common/data-grid-fields/DeleteRecordMenuItem";
import ConditionalField, {
  ForTrue,
  ForFalse,
} from "../../common/data-grid-fields/ConditionalField";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";

const ListActions = () => {
  const { basePath } = useListContext();
  return (
    <>
      <CreateButton basePath={basePath} />
    </>
  );
};

export const RolesList = (props: IResourceListProps) => {
  const themeName = useSelector((state: AppState) => state.theme);
  const theme: Theme = useTheme();

  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={BeenHereOutlined} />}
        className="content-list"
        title="resources.admin-roles.name"
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={
          <ListSearchFilter
            searchFields={["name"]}
            className="roles-list-filter"
          />
        }
        {...props}
      >
        <Datagrid>
          <TextField source="name" label="resources.admin-roles.labels.name" />
          <FunctionField<RoleListDto & Record>
            source="isDefault"
            label="resources.admin-roles.labels.isDefault"
            headerClassName="centered-content"
            render={(record) =>
              record?.isDefault ? (
                <div className="centered-content">
                  <CheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.success.dark
                          : theme.palette.success.light,
                    }}
                  />
                </div>
              ) : null
            }
          />
          <FunctionField<RoleListDto & Record>
            source="isStatic"
            className="centered-content"
            label="resources.admin-roles.labels.isStatic"
            headerClassName="centered-content"
            render={(record) =>
              record?.isStatic ? (
                <div className="centered-content">
                  <CheckBoxIcon
                    style={{
                      color:
                        themeName === "dark"
                          ? theme.palette.success.dark
                          : theme.palette.success.light,
                    }}
                  />
                </div>
              ) : null
            }
          />
          <ConditionalField
            conditionValue={true}
            conditionOperator="equals"
            expression={(record) =>
              record.isDefault || record.isAssigned || record.isStatic
            }
          >
            <ForTrue>
              <ActionsField hasShow={props.hasShow} />
            </ForTrue>
            <ForFalse>
              <ActionsField hasShow={props.hasShow}>
                <DeleteRecordMenuItem confirmTitle="resources.admin-roles.labels.deleteRole" />
              </ActionsField>
            </ForFalse>
          </ConditionalField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
